const options = [
  {
    key: '',
    label: 'sidebar.dashboard',
    leftIcon: 'dashboard',
    roles: ['FBB Operations', 'Admin', 'Marketing Ops', 'Tester']
  },
  {
    key: 'applications',
    label: 'sidebar.applications',
    leftIcon: 'container',
    roles: [
      'FBB Operations',
      'Customer Service',
      'DIGI Store Staff',
      'DIGI Dealer',
      'GENEX',
      'Admin',
      'DIGI Store Manager',
      'Marketing Ops',
      'Telesales Staff',
      'Telesales Manager',
      'Performance Analyst',
      'Tester'
    ]
  },
  {
    key: 'leads',
    label: 'sidebar.leads',
    leftIcon: 'container',
    roles: ['FBB Operations', 'Admin', 'Tester']
  },
  {
    key: 'corporateApplications',
    label: 'sidebar.corporateApplications',
    leftIcon: 'container',
    roles: ['Admin', 'Corporate Admin', 'Corporate Dealer', 'Marketing Ops']
  },
  {
    key: 'radius-profiles',
    label: 'sidebar.radiusProfiles',
    leftIcon: 'user',
    roles: ['FBB Operations', 'Corporate Admin', 'Admin', 'Tester']
  },
  {
    key: 'groups',
    label: 'sidebar.radiusGroups',
    leftIcon: 'team',
    roles: ['FBB Operations', 'Admin', 'Tester']
  },
  {
    key: 'internet-protocol',
    label: 'sidebar.internetProtocol',
    leftIcon: 'apartment',
    roles: ['Corporate Admin', 'Admin']
  },
  {
    key: 'address-upload',
    label: 'sidebar.addressUpload',
    leftIcon: 'home',
    roles: ['Wholesales', 'Admin', 'FBB Operations', 'Tester']
  },
  {
    key: 'marketingOps',
    label: 'sidebar.marketingOps',
    leftIcon: 'desktop',
    roles: ['Admin', 'Marketing Ops'],
    children: [
      {
        key: 'serial-upload',
        label: 'sidebar.serialUpload',
        leftIcon: 'container',
        roles: ['Admin', 'Marketing Ops']
      },
      {
        key: 'saf-upload',
        label: 'sidebar.safUpload',
        leftIcon: 'container',
        roles: ['Admin', 'Marketing Ops']
      }
    ]
  },
  {
    key: 'users',
    label: 'sidebar.users',
    leftIcon: 'idcard',
    roles: ['Admin', 'User Admin']
  },
  {
    key: 'settings',
    label: 'sidebar.operations',
    leftIcon: 'desktop',
    roles: ['FBB Operations', 'Admin', 'Marketing Ops'],
    children: [
      {
        key: 'plans',
        label: 'sidebar.plans',
        leftIcon: 'apartment',
        roles: ['FBB Operations', 'Admin']
      },
      {
        key: 'simserialnumbers',
        label: 'sidebar.serialNumbers',
        leftIcon: 'barcode',
        roles: ['FBB Operations', 'Admin']
      },
      {
        key: 'tdc-csv',
        label: 'sidebar.tdccsv',
        leftIcon: 'container',
        roles: ['FBB Operations', 'Admin']
      },
      {
        key: 'appointment-config',
        label: 'sidebar.appointmentConfig',
        leftIcon: 'container',
        roles: ['FBB Operations', 'Admin', 'Marketing Ops']
      },
      {
        key: 'installers',
        label: 'sidebar.installers',
        leftIcon: 'user',
        roles: ['FBB Operations', 'Admin', 'Marketing Ops']
      },
      {
        key: 'installers/regions',
        label: 'sidebar.installer_region',
        leftIcon: 'global',
        roles: ['FBB Operations', 'Admin', 'Marketing Ops']
      }
    ]
  }
];
export default options;
